export default "__VITE_ASSET__f5eba942__"